export const bogConstants = {
  messageBus: {
    statusTopic: 'wh.sports.account.flags.BOG',
    optInTopic: 'wh.sports.account.flags.set.BOG_OPT_IN',
  },
  status: {
    notAvailable: null,
    eligible: 'ELIGIBLE',
    optedIn: 'OPTED_IN',
  },
  enabledLocales: ['en-gb'],
};
